import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  stores: [],
  storeById: {},
  storeDetail: "",
  status: "idle",
  notification: {},
  error: null,
  loading: false,
  isSidebarVisible: true,
};

const storeSlice = createSlice({
  name: "store",
  initialState,
  reducers: {
    setStorDetail: (state, action) => {
      state.storeDetail = action.payload;
      state.status = "succeeded";
    },
    createStore: (state, action) => {
      state.stores.push(action.payload);
    },
    setStores: (state, action) => {
      state.stores = action.payload;
      state.status = "succeeded";
    },
    setStoreById: (state, action) => {
      state.storeById = action.payload;
      state.status = "succeeded";
    },
    updateStore: (state, action) => {
      const { id, updatedData } = action.payload;
      const existingStore = state.stores?.find((store) => store?.SID === id);
      if (existingStore) {
        Object.assign(existingStore, updatedData);
      }
    },
    updateStoreStatus: (state, action) => {
      const { newStatus } = action.payload;
      state.storeDetail = {
        ...state.storeDetail,
        currentStoreStatus: newStatus, // Add or update current status in storeDetail
      };
      state.status = "succeeded";
    },
    setNotification: (state, action) => {
      state.notification = action.payload;
      state.status = "succeeded";
    },
    deleteStore: (state, action) => {
      state.stores = state?.stores?.filter(
        (store) => store.SID !== action.payload
      );
    },
    setLoading: (state, action) => {
      state.status = "loading";
      state.loading = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
      state.status = "failed";
    },
    setSidebarVisible: (state, action) => {
      state.isSidebarVisible = action.payload;
    },
  },
});

export const {
  setStorDetail,
  createStore,
  setStores,
  setStoreById,
  updateStore,
  updateStoreStatus,
  deleteStore,
  setLoading,
  setError,
  setNotification,
  setSidebarVisible,
} = storeSlice.actions;

export default storeSlice.reducer;
